import { RevampRichText } from './RevampRichText';

interface RevampSectionHeadingProps {
    /** The module's optional h3 title column. */
    contentHTML?: string;
}

/**
 * Ruled heading above a gallery or collection grid (Figma 2479:70455): a
 * 10%-black hairline with the authored title beneath it, at 48px to match the
 * body headings in the prose around it, at the design's 400 weight rather than
 * the browser's bold default.
 *
 * Renders nothing when the module has no title column or it is left empty, so
 * galleries built from the untitled presets keep their bare grid.
 *
 * The design truncates the label to one line, which suits a fixed Figma text
 * layer but would silently hide authored copy, so the title wraps instead.
 */
export const RevampSectionHeading = ({
    contentHTML,
}: RevampSectionHeadingProps) => {
    if (!contentHTML) return null;

    return (
        <div className="px-4.5 md:px-[3rem]">
            {/* The heading sits tight to its grid, so the h3's usual bottom
                margin is dropped in favour of the grid's own top margin. The
                md: tracking is spelled out to beat RevampRichText's own
                md:[&_h3] tracking, which would otherwise win at that width. */}
            <RevampRichText
                contentHTML={contentHTML}
                promoteHeading
                className="border-t border-solid border-black/10 pt-3 text-[#1f1f21] md:pt-[0.8125rem] [&_h2]:mb-0 [&_h2]:text-[1.25rem] [&_h2]:leading-[1.25] [&_h2]:font-normal [&_h2]:tracking-[-0.01em] md:[&_h2]:mb-0 md:[&_h2]:text-[3rem] md:[&_h2]:leading-[2.5rem] md:[&_h2]:tracking-[-0.01em]"
            />
        </div>
    );
};
